import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-display font-bold text-black bg-amber-400 rounded-full overflow-hidden group transition-all hover:bg-amber-300 hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]';
  const widthClass = fullWidth ? 'w-full' : '';
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-191">
        {children}
        <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-192" />
      </span>
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-193" />
    </>;
  if (href) {
    return <a href={href} className={`${baseStyles} ${widthClass} ${className}`} data-id="element-194">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={`${baseStyles} ${widthClass} ${className}`} data-id="element-195">
      {content}
    </button>;
}